import { FC } from "react";
import { useI18n } from "../../../hooks/useTranslations";
import { useCostTypesApi } from "../../../http/costTypes/api";
import HistoryDialog from "../../ui/HistoryDialog";
import VersionDialog from "../../ui/VersionDialog";

interface CostTypesHistoryDialogProps {
  itemToShowVersionsId: string;
  itemVersionToShowVersions: number;
  onClose: () => void;
}

const areDkvProductCodesEqual = (current?: string[], next?: string[]) => {
  const currentValues = current ?? [];
  const nextValues = next ?? [];

  return (
    currentValues.length === nextValues.length && currentValues.every((value, index) => value === nextValues[index])
  );
};

const formatDkvProductCodes = (values?: string[]) => values?.join(", ") ?? "";

const CostTypesHistoryDialog: FC<CostTypesHistoryDialogProps> = ({
  itemToShowVersionsId,
  itemVersionToShowVersions,
  onClose,
}) => {
  const i18n = useI18n();
  const costTypesApi = useCostTypesApi();

  return (
    <HistoryDialog
      title={i18n.t.costTypes.versions}
      lastVersion={itemVersionToShowVersions}
      entityId={itemToShowVersionsId}
      getEntityVersionHook={costTypesApi.getAdminCostTypeVersion}
      getHistory={costTypesApi.getAdminCostTypeHistory}
      onClose={onClose}
      renderForm={(headers, dataVersion) => (
        <>
          <VersionDialog.Table headers={headers}>
            {dataVersion.current?.name != dataVersion.next.name && (
              <tr>
                <VersionDialog.Field
                  label={i18n.t.common.name}
                  value={dataVersion.current?.name}
                  edited={dataVersion.next.name}
                />
              </tr>
            )}
            {dataVersion.current?.category?.id != dataVersion.next.category?.id && (
              <tr>
                <VersionDialog.Field
                  label={i18n.t.common.category}
                  value={dataVersion.current?.category?.name}
                  edited={dataVersion.next.category?.name}
                />
              </tr>
            )}
            {!areDkvProductCodesEqual(dataVersion.current?.dkvProductCodes, dataVersion.next.dkvProductCodes) && (
              <tr>
                <VersionDialog.Field
                  label={i18n.t.common.dkvProductCodes}
                  value={formatDkvProductCodes(dataVersion.current?.dkvProductCodes)}
                  edited={formatDkvProductCodes(dataVersion.next.dkvProductCodes)}
                />
              </tr>
            )}
            {dataVersion.current?.pkwAccountingNumber != dataVersion.next.pkwAccountingNumber && (
              <tr>
                <VersionDialog.Field
                  label={i18n.t.common.pkwAccountingNumber}
                  value={dataVersion.current?.pkwAccountingNumber}
                  edited={dataVersion.next.pkwAccountingNumber}
                />
              </tr>
            )}
            {dataVersion.current?.lkwAccountingNumber != dataVersion.next.lkwAccountingNumber && (
              <tr>
                <VersionDialog.Field
                  label={i18n.t.common.lkwAccountingNumber}
                  value={dataVersion.current?.lkwAccountingNumber}
                  edited={dataVersion.next.lkwAccountingNumber}
                />
              </tr>
            )}
            {dataVersion.current?.pkwSuperiorAccountingNumber != dataVersion.next.pkwSuperiorAccountingNumber && (
              <tr>
                <VersionDialog.Field
                  label={i18n.t.common.pkwSuperiorAccountingNumber}
                  value={dataVersion.current?.pkwSuperiorAccountingNumber}
                  edited={dataVersion.next.pkwSuperiorAccountingNumber}
                />
              </tr>
            )}
            {dataVersion.current?.costObject != dataVersion.next.costObject && (
              <tr>
                <VersionDialog.Field
                  label={i18n.t.common.costObject}
                  value={dataVersion.current?.costObject}
                  edited={dataVersion.next.costObject}
                />
              </tr>
            )}
          </VersionDialog.Table>
        </>
      )}
    />
  );
};

export default CostTypesHistoryDialog;
